<template>
    <b-modal :id="id"
             :no-close-on-backdrop="true"
             :title="$t('uom')" ref="innermodal" @hide="mhide">
        <form ref="form">
            <div v-if="$v.$error" class="alert alert-danger x-error">
                <div class="error" v-if="!$v.model.Name.required">- សូមធ្វើការបញ្ជូលឈ្មោះ</div>
                <div class="error" v-if="!$v.model.NameEn.required">- សូមធ្វើការបញ្ជូលឈ្មោះអង់គ្លេស</div>
                <div class="error" v-if="!$v.model.Code.required">- សូមធ្វើការបញ្ជូលកូដ</div>
            </div>
            <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                <div>
                    <input type="text" class="form-control"
                        :placeholder="$t('name')"
                        v-model="$v.model.Name.$model" />
                </div>
            </div>
            <div class="form-group" :class="{ 'form-group-error': $v.model.NameEn.$error }">
                <div>
                    <input type="text" class="form-control"
                           :placeholder="$t('name_en')"
                           v-model="$v.model.NameEn.$model" />
                </div>
            </div>
            <div class="form-group" :class="{ 'form-group-error': $v.model.Code.$error }">
                <div>
                    <input type="text" class="form-control"
                           :placeholder="$t('code')"
                           v-model="$v.model.Code.$model" />
                </div>
            </div>
            <b-form-group>
                <b-form-textarea v-model="model.Description" :placeholder="$t('description')"/>
            </b-form-group>
        </form>
        <div slot="modal-footer">
            <b-btn variant="primary" @click="clickSaveHandler"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn> &nbsp;
            <b-btn variant="danger" @click="closed"><i class="fa fa-times" aria-hidden="true"></i> {{$t('close')}}</b-btn>
        </div>
    </b-modal>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    export default {
        props:{
            id: {
                type: String,
                default: ''
            },
            value: {
                type: Object,
                default: null
            },
            isUpdate: {
                type: Boolean,
                default: false
            }
        },
        data: function(){
            return {
                model: {
                    Name: '',
                    NameEn: '',
                    Code: ''
                },
                update: this.isUpdate
            }
        },
        validations:{
            model: {
                Name: { required },
                NameEn: { required},
                Code: {required}
            }
        },
        methods: {
            clickSaveHandler(){
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    var loading = this.$loading.show();
                    let action = 'uom/save';
                    if(this.update){
                        action = 'uom/update';
                    }
                    this.$api().post(action, this.model).then(res => {
                        if(this.$isValid(res)){
                            this.model = {
                                Name: '',
                                NameEn: '',
                                Code: ''
                            };
                            this.$refs.innermodal.hide();
                            this.$emit('done')
                        }
                    }).finally(function(){ loading.hide(); });
                }
            },
            closed: function(){
                this.resetForm();
                this.$refs.innermodal.hide();
            },
            mhide: function(){
                this.resetForm();
            },
            resetForm: function(){
                this.$v.$reset();
                this.model = {
                    Name: '',
                    NameEn: '',
                    Code: ''
                };
            }
        },
        watch: {
            value: function(value){
                if(value != undefined && value != null){
                    this.model = value;
                }else{
                    this.model = {}
                }
            },
            isUpdate: function(value){
                this.update = value
            }
        }
    }
</script>